// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer > div[data-v-5421e404]:last-child {\n  border-radius: 1.5rem 1.5rem 0 0;\n}", "",{"version":3,"sources":["webpack://./resources/js/Layouts/Guest.vue"],"names":[],"mappings":"AACA;EACE,gCAAA;AAAF","sourcesContent":["\n.footer > div:last-child {\n  border-radius: 1.5rem 1.5rem 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
